import { ENV as base } from './environment.base';
import { InstallmentType } from '@ux/entities/installment-types';

const env = {
  ...base,
  urlPath: 'https://travel.rappi.com.pe',
  webview_auth: 'prodpe',
  production: true,
  localeCMS: 'pe',
  language: 'ES',
  defaultLocale: 'es-PE',
  branchcode: '5',
  domain_checkout: 'rappi.com.pe',
  desktop_checkout: 'https://www.rappi.com.pe/checkout',
  web_login: 'https://www.rappi.com.pe/login?url_redirect={redirect}',
  user_service: 'rappipe',
  currency_precision: 2,
  footer_operated_by: 'Operado por Rappi Travel S.A.P.I de C.V. - SECTUR RNT #04090161508',
  proxy_images: 'https://services.rappi.pe/api/ms/travel-imageproxy',
  rappipro_link: 'https://pro.rappi.com/peru',
  covid_location_restrict: [],
  travel_city_limit: 10,
  validate_search: {
    ...base.validate_search,
    buses: {
      ...base.validate_search.buses,
      open_search: true
    },
    flighs: {
      ...base.validate_search.flighs,
      open_search: true,
      international_dates: {
        minDate: '',
        maxDate: ''
      },
      national_dates: {
        minDate: '',
        maxDate: ''
      },
    }
  },
  countryModules: {
    ...base.countryModules,
    booking: {
      ...base.countryModules.booking,
      call_support: true,
      exchange_rate: {
        ...base.countryModules.booking.exchange_rate,
        enabled: true,
        currency_to: 'PEN',
        currency_to_name: 'Soles',
        show_currency_sufix: false
      },
      go_to_pay_button: {
        ...base.countryModules.booking.go_to_pay_button,
        enabled_price_info: true
      }
    },
    user_history: {
      ...base.countryModules.user_history,
      exchange: true,
      can_do_payment: true,
      disabled_airlines_exchange: [],
      seatMap: false
    },
    cancellation: {
      ...base.countryModules.cancellation,
      hotel_enabled: false,
      flight_enabled: true,
      disabled_by_airlines: ['JA', 'JZ', 'WJ']
    },
    header: {
      ...base.countryModules.header,
      show_disabled_products: false,
    },
    installments: {
      partner_type: InstallmentType.NONE,
    },
    banner_results: {
      ...base.countryModules.banner_results,
      banner_enabled_flighs: false,
      banner_enabled_hotels: false,
      banner_enabled_autos: false,
      banner_enabled_air_packages: false,
      banner_enabled_buses: false,
      banner_flights_available: 'RAPPI_CARD',
      banner_hotels_available: 'RAPPI_CARD',
      banner_autos_available: 'RAPPI_CARD',
      banner_air_packages_available: 'RAPPI_CARD',
      banner_buses_available: 'RAPPI_CARD',
      cashback: {
        flights: { total: 5, card: 5, credits: 5, references: ['32827_2091653549'] },
        hotels: { total: 5, card: 5, credits: 5, references: ['32828_2091653551'] },
        autos: { total: 5, card: 5, credits: 5, references: ['32828_2091653551'] },
        air_packages: { total: 5, card: 5, credits: 5, references: [888360, 888363] },
        buses: { total: 5, card: 5, credits: 5, references: ['32827_2091653549'] },
      }
    }
  },
  countryInfo: {
    ...base.countryInfo,
    name: 'Perú',
    phone_prefix: '+51',
    support_phone: 16429998,
    iso_code: 'PE',
    currency_code: 'USD',
    locale: 'es-PE',
    icon: 'https://images.rappi.com/web/countries-flags/pe.webp',
    instagram: 'https://www.instagram.com/rappi.pe/?hl=es',
    twitter: 'https://twitter.com/rappiperu?lang=es',
    facebook: 'https://www.facebook.com/RappiColombia',
    country_id: 9,
    complaints_book: 'http://librodereclamacionesperu.com/10524305.html',
    footer_pdf: 'https://rappi-images-upload-co.s3.amazonaws.com/web/travel/PE/DOCS/CONSTANCIA_N_743-AGVT_firmado.pdf',
    minutes_to_restart_searches: 25,
    displayTUA: false,
    tzIdentifier: 'America/Lima'
  },
  default_address: {
    ...base.default_address,
  },
  header_redirect: {
    ...base.header_redirect,
    link: 'https://www.rappi.com.pe/',
    title: 'rappi.com.pe'
  },
  footer_links: {
    ...base.footer_links,
    register_restaurant: 'https://merchants.rappi.com/es-pe?utm_source=rappicom&utm_medium=footer&utm_campaign=referral',
    restaurants: 'https://www.rappi.com.pe/restaurantes',
    markets: 'https://www.rappi.com.pe/aliados/tipo/market',
    courier: 'https://www.rappi.com.pe/courier-hours',
    data_treatment_rappi: 'https://legal.rappi.com/peru/aviso-de-privacidad-usuarios/',
    // eslint-disable-next-line max-len
    aerocivil: 'https://www.profeco.gob.mx/politicasaviacion/pdf/DERECHOS%20Y%20OBLIGACIONES%20VIAJAR%20EN%20AVI%C3%93N%20QR%20(vf).pdf',
    terms_rappi: 'https://legal.rappi.com/peru/politica-de-privacidad-de-rappi-y-tratamiento-de-datos-personales/',
  },
  api: {
    ...base.api,
    services: 'https://services.rappi.pe',
    travel_flight_content: 'https://services.grability.rappi.com',
    server: 'https://v2.grability.rappi.com',
    netactica: 'https://reservas.servicesnet.agency/netcoreapi',
    images: 'https://reservas.servicesnet.agency/Images',
    search: 'https://services.rappi.com',
    travel_data_info: 'https://services.rappi.pe/api/ms/travel-data-info',
    travel_order_billing: 'https://services.rappi.pe/api/ms/travel-order-billing',
    travel_alerts: 'https://services.rappi.pe/api/ms/travel-alerts',
    travel_static_content: 'https://services.rappi.pe/api/travel-static-content-ms',
    travel_cms: 'https://services.rappi.pe/api/travelcms',
    static_search_hotel_autocomplete: 'https://services.grability.rappi.com/api/travel-hotel-search',
    lifemiles_integration: 'https://services.rappi.pe/api/ms/loyalty-notification'
  },
  booking_options: {
    ...base.booking_options,
  },
  store_configuration: {
    ...base.store_configuration,
    STORE_ID: 1923230278,
    SUPPORT_LINK: 'gbrappi://com.grability.rappi?goto=chat&chat_type=non_live_chat&chat_key=HC_NO_RELATED_TO_ORDERS'
  },
  animation: {
    url: '/assets/libs/ngx-lottie/PE/waiting_pe_5.json',
    options: {
      width: '85vw',
      height: 'auto',
      maxWidth: '85vw',
      maxHeight: 'auto',
      marginLeft: '0px'
    }
  },
};

export const environment = env;
